<script>
    import ProductCardIcons from "@petoneer/components/ProductCardIcons";

    export default {
        name: "ProductCardFeatures",
        components: { ProductCardIcons },
        props: {
            icons: [Object, Array],
            list: Array,
            isOdd: Boolean,
        },
    };
</script>

<template>
    <div class="p-c-features">
        <ul class="p-c-features__list">
            <li v-for="(item, i) in list" :key="i">{{ item.name }}</li>
        </ul>
        <div class="p-c-features__icons">
            <product-card-icons :icons="icons" :is-odd="isOdd"></product-card-icons>
        </div>
    </div>
</template>

<style lang="scss">
    .p-c-features {
        border-top: 1px solid #d6e0ea;
        display: flex;
        flex-direction: column-reverse;
        margin-bottom: 12px;
        @include bp($bp-tablet-sm) {
            justify-content: space-between;
            align-items: flex-start;
            flex-direction: row;
            margin-bottom: 24px;
        }
    }
    .p-c-features__list {
        margin-top: 4px;
        @include bp($bp-tablet-sm) {
            margin-top: 6px;
        }
        li {
            font-weight: 400;
            font-size: 10px;
            line-height: 12px;
            @include bp($bp-tablet-sm) {
                font-size: 12px;
                line-height: 18px;
            }
        }
    }
    .p-c-features__icons {
        @include bp($bp-tablet-sm) {
            margin-top: 2px;
        }
    }
</style>
